import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { GIT_VERBS } from "./git-verbs-constants";
import { requestedRepos } from "./requested-repos";
import { verbLabel } from "./verb-label";

export function describeCloneRepo(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const names = requestedRepos({
    repoFullName:
      typeof record.repoFullName === "string" ? record.repoFullName : undefined,
    repoFullNames: Array.isArray(record.repoFullNames)
      ? record.repoFullNames.filter((name) => typeof name === "string")
      : undefined,
  });
  const target =
    names.length > 1
      ? `${names.length} repositories`
      : (names[0] ?? "the repository");
  return verbLabel(state, GIT_VERBS.CLONE, target);
}
